<template>
<!--  <router-view style="min-height: 600px;" />-->
  <div >
<!--    <keep-alive include="HomePageAds" >-->
    <router-view style="min-height: 500px;" />
<!--    </keep-alive>-->
   <footer style=" background:rgba(255,255,255,1);
  box-shadow:0px -1px 0px 0px rgba(229,229,229,1);" >
    <HomeFooter/>
  </footer>

  </div>
</template>
<script>
  import  HomeFooter from '@/components/home-footer/home-footer.vue'

  export default {
    components:{
      HomeFooter,
    },

  }
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/views/Layout/main.vue